export default __webpack_public_path__ + "static/media/banode_polygon.ce43bd29.png";